import { every, isNil } from 'lodash'
import { ViewState } from 'ms-map-gl'
import { useMemo } from 'react'
import { useMap } from '~map-preview/states/map'
import { useViewState } from '~map-preview/states/viewState'

export const useInitialViewState = () => {
  const viewState = useViewState()
  const mapData = useMap()

  // INFO: Set memorize initial view state for preventing value change
  const initialViewState = useMemo(() => {
    if (every(viewState, isNil)) {
      return {
        bounds: mapData?.bbox
      }
    }
    return { ...viewState, bounds: mapData?.bbox }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapData?.bbox, viewState])

  return initialViewState as ViewState
}
